import type { DisciplineStageComment } from '../model/interfaces'

/** A further page can repeat a row the list already holds (a comment added since the first page shifts the cursor). */
export const mergeStageComments = (
  current: DisciplineStageComment[],
  incoming: DisciplineStageComment[],
): DisciplineStageComment[] => {
  const knownIds = new Set(current.map(comment => comment.id))

  return [...current, ...incoming.filter(comment => !knownIds.has(comment.id))]
}

/** The list reads a replica that may lag behind a write, so the row the write returned is put in place by hand:
 *  an edited row is replaced where it is, a new one goes on top (the list is newest first). */
export const upsertStageComment = (
  current: DisciplineStageComment[],
  comment: DisciplineStageComment,
): DisciplineStageComment[] => {
  const index = current.findIndex(item => item.id === comment.id)
  if (index === -1) return [comment, ...current]

  return current.map(item => item.id === comment.id ? comment : item)
}
